import FaveNotification from './FaveNotification';
import FaveNotificationContainer from './FaveNotification.container';
export default FaveNotificationContainer(FaveNotification);
//# sourceMappingURL=index.js.map